import { createSlice } from '@reduxjs/toolkit';
import { LevelState } from '../../types/level';

const initialState: LevelState = {
  isLoading: false,
  levelList: {},
  levelListParams: {},
  level: null,
};

const slice = createSlice({
  name: 'level',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getLevelListSuccess(state, action) {
      state.isLoading = false;
      state.levelList = action.payload;
    },

    setLevelListParams(state, action) {
      state.levelListParams = action.payload;
    },

    getLevelSuccess(state, action) {
      state.isLoading = false;
      state.level = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getLevelListSuccess,
  getLevelSuccess,
  setLevelListParams,
} = slice.actions;
